export default __webpack_public_path__ + "static/expert-1-de31ba81d31d386a6b88de6938994c9e.png";